export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api/v1"
    : "https://neoncapbe-production-21f2.up.railway.app/api/v1";
